/**
 * Coups de pouce — Attendu 1077 « Connaître la somme des angles d'un triangle,
 * calculer le troisième angle connaissant les deux autres ».
 *
 * troisieme_saisie : la méthode (180 moins les deux autres, angle droit à 90°,
 * angles à la base égaux) ; l'exemple (revue 2026-09-02) est le piège central
 * de la carte, l'angle droit codé mais non écrit. SVG pas à pas piloté par les
 * flèches de la sheet (data-etapes / data-caption).
 *
 * possible_tableau_vf : aide MÉTHODE (les lignes se vérifient par un même geste :
 * additionner, comparer à 180) ; l'exemple teste deux affirmations avec des nombres.
 */

const SVG_ANGLE_DROIT = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Calculer le troisième angle d'un triangle, en 3 étapes à faire défiler avec les flèches. Un triangle PQR est rectangle en P, son angle en Q mesure 34 degrés, on cherche l'angle en R. Étape 2 : le petit carré en P, c'est un angle de 90 degrés, il compte même s'il n'est pas écrit. Étape 3 : 180 moins 90 moins 34 égale 56 degrés, et on vérifie que 90 plus 34 plus 56 font 180. Le troisième angle, c'est 180 moins les deux autres">
  <style>
    @keyframes cp1077-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1077-pop { opacity: 0; animation: cp1077-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Rectangle en P, 34° en Q : combien en R ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="0" data-caption="2" font-family="system-ui,sans-serif">L'angle droit compte : 90°, même sans le nombre</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="3" font-family="system-ui,sans-serif">180 − 90 − 34 = 56°</text>

  <!-- ── La figure (étape 1) ─────────────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <path d="M 51.6 171.3 L 161.9 151.8 L 38.5 96.9 Z" fill="#eff6ff" stroke="#1E3A8A" stroke-width="2.2"/>
    <polyline points="62.4,169.4 60.5,158.5 49.7,160.4" fill="none" stroke="#111827" stroke-width="1.8"/>
    <path d="M 146.1 154.6 L 146.0 153.7 L 145.9 152.7 L 145.9 151.8 L 145.9 150.8 L 146.0 149.9 L 146.2 148.9 L 146.4 148.0 L 146.6 147.1 L 146.9 146.2 L 147.3 145.3" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <path d="M 41.3 112.6 L 42.8 112.3 L 44.3 111.8 L 45.7 111.2 L 47.1 110.4 L 48.3 109.5 L 49.5 108.5 L 50.6 107.3 L 51.6 106.1 L 52.4 104.8 L 53.1 103.4" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <text x="120.2" y="150.7" font-size="12.5" font-weight="700" fill="#B45309" text-anchor="middle">34°</text>
    <text x="59.4" y="127.7" font-size="12.5" font-weight="700" fill="#B45309" text-anchor="middle">?</text>
    <text x="40.1" y="187.4" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">P</text><text x="177.7" y="159.2" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">Q</text><text x="26.9" y="90.9" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">R</text>
  </g>

  <!-- ── L'angle caché (étape 2) ─────────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1077-pop">
      <polyline points="62.4,169.4 60.5,158.5 49.7,160.4" fill="none" stroke="#1D9E75" stroke-width="2.8"/>
      <text x="71.1" y="147.4" font-size="12.5" font-weight="700" fill="#1D9E75" text-anchor="middle">90°</text>
      <text x="192" y="96" font-size="12" font-weight="700" fill="#1D9E75">Le petit carré, c'est</text>
      <text x="192" y="111" font-size="12" font-weight="700" fill="#1D9E75">un angle de 90°.</text>
      <text x="192" y="133" font-size="11.5" font-weight="600" fill="#1e293b">Il compte, même s'il</text>
      <text x="192" y="147" font-size="11.5" font-weight="600" fill="#1e293b">n'est pas écrit.</text>
    </g>
  </g>

  <!-- ── Le calcul (étape 3) ─────────────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1077-pop">
      <rect x="50.4" y="115.7" width="18" height="15" fill="#eff6ff"/>
      <text x="59.4" y="127.7" font-size="12.5" font-weight="700" fill="#1D9E75" text-anchor="middle">56°</text>
      <rect x="186" y="164" width="166" height="22" rx="8" fill="#ecfdf5" stroke="#1D9E75"/>
      <text x="269" y="179" font-size="12.5" font-weight="800" fill="#1D9E75" text-anchor="middle">180 − 90 − 34 = 56°</text>
      <text x="269" y="204" font-size="11.5" font-weight="700" fill="#1e293b" text-anchor="middle">Vérif. : 90 + 34 + 56 = 180 ✓</text>
      <text x="180" y="240" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Le troisième angle, c'est 180 moins les deux autres.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const SVG_TESTER = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Décider si un triangle est possible, en 3 étapes à faire défiler avec les flèches. Deux affirmations : un triangle peut avoir des angles de 70 et 95 degrés ; un triangle peut avoir deux angles obtus. Première : 70 plus 95 font 165, 180 moins 165 font 15, le troisième angle existe, c'est vrai. Seconde : un angle obtus dépasse 90 degrés, 91 plus 91 font déjà 182, plus que 180, aucun troisième angle possible, c'est faux. Additionne, compare à 180">
  <style>
    @keyframes cp1077b-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1077b-pop { opacity: 0; animation: cp1077b-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">On teste chaque affirmation avec des nombres</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">70 + 95 = 165, il reste 15° pour le troisième : VRAI</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Deux obtus : déjà plus de 180° à eux deux : FAUX</text>

  <!-- ── Les deux affirmations (étape 1) ─────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <rect x="12" y="40" width="336" height="40" rx="8" fill="#eff6ff" stroke="#1E3A8A"/>
    <text x="22" y="57" font-size="12" font-weight="700" fill="#1e293b">① Un triangle peut avoir des angles</text>
    <text x="22" y="72" font-size="12" font-weight="700" fill="#1e293b">de 70° et 95°.</text>
    <rect x="12" y="142" width="336" height="26" rx="8" fill="#eff6ff" stroke="#1E3A8A"/>
    <text x="22" y="159" font-size="12" font-weight="700" fill="#1e293b">② Un triangle peut avoir deux angles obtus.</text>
  </g>

  <!-- ── Test de la première (étape 2) ───────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1077b-pop">
      <text x="22" y="98" font-size="12" font-weight="700" fill="#1e293b">70 + 95 = 165</text>
      <text x="150" y="98" font-size="12" font-weight="700" fill="#1e293b">180 − 165 = 15</text>
      <text x="22" y="116" font-size="12" font-weight="700" fill="#1D9E75">Le troisième angle existe (15°) : VRAI ✓</text>
      <rect x="12" y="40" width="336" height="40" rx="8" fill="none" stroke="#1D9E75" stroke-width="2.4"/>
    </g>
  </g>

  <!-- ── Test de la seconde (étape 3) ────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1077b-pop">
      <text x="22" y="186" font-size="12" font-weight="700" fill="#1e293b">Obtus = plus de 90°.</text>
      <text x="150" y="186" font-size="12" font-weight="700" fill="#1e293b">Au moins 91 + 91 = 182</text>
      <text x="22" y="204" font-size="12" font-weight="700" fill="#B45309">Déjà plus de 180 à eux deux : FAUX ✗</text>
      <rect x="12" y="142" width="336" height="26" rx="8" fill="none" stroke="#B45309" stroke-width="2.4"/>
      <text x="180" y="240" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Additionne, compare à 180.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_TROISIEME = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Dans un triangle, les trois angles font toujours 180° à eux trois.**',
                '**Deux angles connus** : le troisième vaut 180 moins les deux autres.',
                "**Triangle rectangle** : l'angle droit fait 90°, même s'il n'est pas écrit. Les deux autres font 90° à eux deux.",
                '**Triangle isocèle** : les deux angles à la base sont égaux. Sommet connu : on enlève le sommet à 180, puis on partage en deux. Base connue : on enlève deux fois la base à 180.',
                '**Vérifie** : tes trois angles additionnés doivent faire 180.',
            ],
        },
        { titre: 'Un exemple', svg: SVG_ANGLE_DROIT },
    ],
};

const AIDE_POSSIBLE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Un triangle existe si ses trois angles font exactement 180° à eux trois**, chacun plus grand que 0.',
                '**Deux angles donnés** : additionne-les. Si le total atteint ou dépasse 180, le triangle est impossible. Sinon le troisième vaut 180 moins ce total.',
                '**Un angle droit vaut 90°, un angle obtus plus de 90°** : remplace le mot par sa valeur avant d\'additionner.',
                '**Triangle isocèle** : deux angles égaux. **Équilatéral** : trois angles de 60°.',
                '**Teste chaque affirmation avec des nombres** : cherche un exemple qui marche, ou montre que la somme ne peut pas faire 180.',
            ],
        },
        { titre: 'Un exemple', svg: SVG_TESTER },
    ],
};

const CP_1077 = {
    troisieme_saisie: AIDE_TROISIEME,
    possible_tableau_vf: AIDE_POSSIBLE,
};

export default CP_1077;
